<template>
  <table class="solution-table">
    <thead>
      <tr>
        <th>ID</th>
        <th>标题</th>
        <th>类别</th>
        <th>操作</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="solution in solutions" :key="solution.id">
        <td>{{ solution.id }}</td>
        <td>{{ solution.title }}</td>
        <td>{{ getCategoryLabel(solution.category) }}</td>
        <td class="action-buttons">
          <button @click="handleEdit(solution)" class="btn-edit">编辑</button>
          <button @click="handleParagraphs(solution)" class="btn-paragraphs">段落管理</button>
          <button @click="handleDelete(solution)" class="btn-delete" :disabled="loading">删除</button>
        </td>
      </tr>
      <tr v-if="solutions.length === 0 && !loading">
        <td colspan="4" class="no-data">暂无数据</td>
      </tr>
      <tr v-if="loading">
        <td colspan="4" class="loading">加载中...</td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { solutionCategories } from '@/config/solutionTemplate.js';

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  solutions: {
    type: Array,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['edit', 'delete', 'paragraphs']);

// 获取类别对应的中文标签
const getCategoryLabel = (categoryValue) => {
  const category = solutionCategories.find(cat => cat.value === categoryValue);
  return category ? category.label : categoryValue;
};

const handleEdit = (solution) => {
  emit('edit', solution);
};

const handleParagraphs = (solution) => {
  emit('paragraphs', solution);
};



const handleDelete = (solution) => {
  emit('delete', solution);
};
</script>

<style scoped>
.solution-table {
  width: 100%;
  border-collapse: collapse;
}

.solution-table th,
.solution-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.solution-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}



.action-buttons {
  display: flex;
  gap: 8px;
}

.btn-edit, .btn-paragraphs, .btn-delete {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s ease;
}

.btn-edit {
  background-color: #007bff;
  color: white;
}

.btn-edit:hover {
  background-color: #0056b3;
}

.btn-paragraphs {
  background-color: #28a745;
  color: white;
}

.btn-paragraphs:hover {
  background-color: #1e7e34;
}



.btn-delete {
  background-color: #dc3545;
  color: white;
}

.btn-delete:hover {
  background-color: #c82333;
}

.btn-delete:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.btn-edit {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}



.btn-delete {
  background-color: #ff4444;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-delete:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.no-data,
.loading {
  text-align: center;
  padding: 20px;
  color: #666;
}
</style>